import { DividerCombinedProps } from './types';

const usePresenter = (props: DividerCombinedProps): DividerCombinedProps => {
  return props;
};

export default usePresenter;
